module.exports = __webpack_public_path__ + "img/2025-08-16d_2.70a893ed.jpg";